'use client'
import { useRouter } from 'next/navigation'
import React, { useState } from 'react'

export default function FormCurso() {
  const [query, setQuery] = useState('')
  const router = useRouter()

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    router.push('/pos-graduacao?search=' + query)
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="flex justify-end">
          <input
            type="text"
            placeholder="Pesquisar"
            className="input input-bordered w-full max-w-xs rounded-none !bg-white !text-black"
            onChange={(e) => setQuery(e.target.value)}
            value={query}
          />
          <button className="absolute bg-footer p-4">
            <svg
              className="h-4 w-4 text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
              />
            </svg>
          </button>
        </div>
      </form>
    </>
  )
}
